import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * Medicine catalog fuzzy-search (api-medicine-service). Backs the "Medicine"
 * search dropdown on the Add / Update forms.
 *
 * Response shape (verified against api-medicine-service model/req_response.go):
 *   { data: [{ id, mCode, medicineName, manufacturerName, formulation, ... }],
 *     total, page, limit }
 *
 * Note the field is `data[]`, NOT `items[]` — worth remembering.
 */
class MedicineCatalogService {
  constructor() {
    this.apiService = new APIService();
  }

  search(queryString, onResponse, onError) {
    const q = encodeURIComponent((queryString || "").trim());
    if (!q) {
      onResponse([]);
      return;
    }
    const url = APIConfig.medicineCatalog.search.format(q);
    return this.apiService.get(
      url,
      (res) => {
        // Normalise to a plain array so the caller doesn't have to know the
        // envelope shape.
        onResponse((res && res.data) || []);
      },
      onError
    );
  }

  /**
   * Full formulation catalog (~125 rows). Returns a plain array of
   *   { code, label, units[], instructions[] }
   * The medicine form derives label / units / instructions maps from a
   * single response — see `fetchFormulationCatalog` in MedicineForm.js.
   */
  formulations(onResponse, onError) {
    return this.apiService.get(
      APIConfig.medicineCatalog.formulations,
      (res) => onResponse(Array.isArray(res) ? res : []),
      onError,
    );
  }

  /**
   * Single formulation lookup by REFLD code. 404 → onError with the
   * platform's standard error envelope.
   */
  formulationByCode(code, onResponse, onError) {
    const url = APIConfig.medicineCatalog.formulationByCode.format(code);
    return this.apiService.get(url, onResponse, onError);
  }

}

export default MedicineCatalogService;
